import LoginManager, {
  FakeLoginService
} from "@emcm-ui/utility-authentication";

const service = new FakeLoginService();

service.activate();

export default new LoginManager(service);
